import React from 'react'

const icon = ({sucursal}) => {
  return (
    <img src={sucursal} style={{width:"20px"} } />
  )
}

export default icon